import {
  VirtualizedListBase,
  virtualizedListDefaultProps,
} from '$common/virtualized-list'
import { EmptySearchResult } from '$common/empty-search-result'
import { SearchListProps } from './with-search-list.types'

export function SearchList<Item, SearchParams>({
  searchHook,
  searchHookParams,
  EmptyStateComponent,
  ...other
}: SearchListProps<Item, SearchParams>) {
  const { loading, searchedItems } = searchHook(searchHookParams)
  const itemCount = searchedItems ? searchedItems.length : 0

  return (
    <VirtualizedListBase
      {...other}
      items={searchedItems}
      itemCount={itemCount}
      loading={loading}
      EmptyStateComponent={
        itemCount === 0 ? EmptySearchResult : EmptyStateComponent
      }
    />
  )
}

SearchList.defaultProps = virtualizedListDefaultProps
